import Main from './PrivacyPoliciesMain'
import Show from './PrivacyPoliciesShow'

const PrivacyPolicies = {
  Main,
  Show,
}

export default PrivacyPolicies
